<template>
    <div class="view">
        <div class="header">
            <vxe-form ref="formRef" :data="queryform" @submit="submitEvent" >
                <vxe-form-item title="助记词" field="MnemonicPhrase"  :item-render="{}">
                    <template #default="params">
                        <vxe-input v-model="queryform.MnemonicPhrase"></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item title="名称" field="Name"  :item-render="{}">
                    <template #default="params">
                        <vxe-input v-model="queryform.Name"></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item align="center"  :item-render="{}">
                    <template #default>
                        <vxe-button type="submit" status="primary" content="查询"></vxe-button>
                        <vxe-button status="success" content="确定选择" @click="SureSelect"></vxe-button>
                        <vxe-button  status="error" content="添加" @click="handleAddnew"></vxe-button>
                    </template>
                </vxe-form-item>
            </vxe-form>
        </div>
        <div class="content">
            <div style="flex: 1;">
                <vxe-table :data="tableData" height="100%" max-height="100%" ref="tableRef" :loading="loading"
                    :checkbox-config="{ labelField: 'spbh', highlight: true }" :row-config="{ isHover: true }">
                    <vxe-column type="checkbox" width="40"></vxe-column>
                    <vxe-column field="sP_BH" title="商品编号" width="80"></vxe-column>
                     <vxe-column field="sP_QM" title="商品全名" min-width="280" show-overflow></vxe-column>
                     <vxe-column field="sP_GG" title="商品名称" width="100"></vxe-column>
                    <vxe-column field="sP_MC" title="品牌" width="120"></vxe-column>
                    <vxe-column field="sP_XH" title="型号" width="260"></vxe-column>
                    <vxe-column field="sP_ZJC" title="助记词" min-width="160" show-overflow></vxe-column>
                    <vxe-column field="sP_DW" title="单位" width="80" align="center">
                        <template #default="{ row }">
                            <vxe-tag status="primary" size="mini">{{ row.sP_DW || '-' }}</vxe-tag>
                        </template>
                    </vxe-column>
                    <vxe-column field="sP_KC" title="库存数量" width="120" align="right">
                        <template #default="{ row }">
                            <span :style="{ color: row.sP_KC < 0 ? '#F56C6C' : '#67C23A', fontWeight: 'bold' }">
                                {{ row.sP_KC ?? 0 }}
                            </span>
                        </template>

                    </vxe-column>
                </vxe-table>
            </div>
            <div>
                <vxe-pager :current-page.sync="pageVO.currentPage" :page-size.sync="pageVO.pageSize"
                    :total="pageVO.total" @page-change="pageChange">

                </vxe-pager>
            </div>
        </div>
            <!-- 选择供货商* -->
    <vxe-modal v-model="showModel" width="40vw" height="30vh" destroy-on-close :title="initialData.usefule+'产品'" > 

      <template #default>
       <addProductComp v-model:initialData="initialData" @submit="handleCloseAddnew" />
      </template>
    </vxe-modal>
    </div>
</template>
<script setup>
import { ref, reactive, defineEmits, defineProps, onMounted } from 'vue'
import addProductComp from '@/components/addComp/addProductComp.vue'
import request from '@/request/request'
const queryform = reactive({ MnemonicPhrase: '', Name: '', PageIndex: 1, PageSize: 10 })
const loading = ref(false)
const tableData = ref([])
const showModel = ref(false)
const initialData = reactive({ usefule: '新增', Product: {} })
const emit = defineEmits(['select', 'cancel'])
const handleAddnew = async () => {
    initialData.usefule = '新增'
    initialData.Product = {}
    showModel.value = true
}
// ✅ 正确：String 类型直接赋值
const props = defineProps({
    MnemonicPhraseProp: {
        type: String,
        default: ''  // 直接赋值
    }
})
const tableRef = ref(null)
const pageVO = reactive({
    total: 0,
    currentPage: 1,
    pageSize: 10
})

const pageChange = ({ pageSize, currentPage }) => {
    pageVO.currentPage = currentPage
    pageVO.pageSize = pageSize
    query()
}
const query = async () => {
    try {
        loading.value = true
        queryform.PageIndex = pageVO.currentPage
        queryform.PageSize = pageVO.pageSize
        const res = await request.post('/Product/GetProducts', queryform)
        tableData.value = res.data
        pageVO.total = res.totalCount

        loading.value = false
    }
    catch (error) {
        console.log(error)
        loading.value = false
    }
}
const handleCloseAddnew = async () => {
    showModel.value = false
    await submitEvent()
}
const submitEvent = async () => {
    showModel.value = false
    pageVO.currentPage = 1
    await query()
}
// ✅ 正确：直接调用 onMounted，不要赋值给变量
onMounted(async () => {
    queryform.MnemonicPhrase = props.MnemonicPhraseProp
    await submitEvent()
})
const SureSelect = () => {
    var tableref = tableRef.value
    emit('select', tableref.getCheckboxRecords())
}
</script>
<style scoped>
.view {
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.content {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
}
</style>